export default "__VITE_ASSET__BR5K1H52__"